import SectionLabel from "./SectionLabel";
import { deliverySteps } from "@/content/homepage";

export default function DeliveryMethod() {
  return (
    <section
      id="approach"
      className="av-section av-method"
      aria-labelledby="av-method-title"
      data-testid="delivery-method-section"
    >
      <div className="av-shell av-method-grid">
        <div>
          <SectionLabel>Delivery model</SectionLabel>
          <h2 id="av-method-title">
            A practical route from planning to implementation.
          </h2>
        </div>
        <ol className="av-step-grid">
          {deliverySteps.map((step) => (
            <li key={step.number}>
              <p className="av-step-label">
                {step.number} / {step.label}
              </p>
              <h3>{step.title}</h3>
              <p>{step.description}</p>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
